// docs/specs/login-setup.md §2 step "phone": a US mobile, 10 digits. "+1", a leading 1, spaces, dashes, dots and
// brackets are stripped; anything else (letters, another country) is not a number we take.
export const toUsDigits = (raw) => {
  const text = String(raw ?? "");
  if (/[^0-9+()\-.\s]/.test(text)) return null;
  const digits = text.replace(/\D/g, "");
  if (digits.length === 10) return digits;
  return digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : null;
};

// Oracle masks as "******0156"; the screen shows "•••-•••-0156". Never the full number.
export const maskedLast4 = (masked) => (masked ? `•••-•••-${String(masked).slice(-4)}` : "");
